import { useSelector } from "react-redux";
import styled from "styled-components";

import BuildingInteriorDisplay from "components/base/BuildingInteriorDisplay";
import { getBuildingData } from "libs/stats";
import { getBuildingInfo } from "redux/selectors/characterSelectors";
import { BuildingModel, BuildingScreen, BuildingTypes } from "types";
import BuildScreen from "./BuildScreen";
import PilotSkills from "./PilotSkills";
import SwitchPilotScreen from "./SwitchPilotScreen";
import SwitchShipScreen from "./SwitchShipScreen";
import TravelScreen from "./TravelScreen";

interface BuildingInteriorWrapperProps {
  bgImage: string;
}

const BuildingInteriorWrapper = styled.div<BuildingInteriorWrapperProps>`
  width: 100vw;
  height: 100vh; // fallback
  height: 100dvh;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 7;
  ${(props) => !!props.bgImage && `background-image: url("${props.bgImage}");`}
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  transition: all 500ms ease-out;
`;

const getBuildingScreens = (building: BuildingModel) => {
  const BUILDING_SCREENS: Record<BuildingTypes, BuildingScreen[]> = {
    shipworks: [
      {
        slug: "build",
        name: "Build Ship",
        component: <BuildScreen />,
        dialog:
          "Level up your starship's stats and install newly unlocked upgrades. God knows your ship could use it. Oh, did I say that last part out loud?",
      },
      {
        slug: "train",
        name: "Train Pilot",
        component: <PilotSkills atShipworks={true} />,
        dialog:
          "Let's get you trained up on some sweet new pilot skills. You don't seem like a fast learner, but I'm a great teacher.",
      },
    ],
    pilotAcademy: [
      {
        slug: "switchShip",
        name: "Switch Ship",
        component: <SwitchShipScreen />,
        dialog:
          "Not happy with your choice of starship class? I don't think your ship is what's holding you back, but you might as well try a new class and see. Switching costs increase with your total medallion count.",
      },
      {
        slug: "switchPilot",
        name: "Switch Pilot",
        component: <SwitchPilotScreen />,
        dialog:
          "Want to switch up your pilot profession? We'll get you set up to learn a new set of pilot skills. Switching costs increase with your total medallion count.",
      },
    ],
    jumpGate: [
      {
        slug: "travel",
        name: "Travel",
        component: <TravelScreen />,
        dialog:
          "Ready to explore the galaxy? Buy a pass to travel to a new planet!",
      },
    ],
    vectorStation: [
      {
        slug: "build",
        name: "Build Ship",
        component: <BuildScreen />,
        dialog:
          "Level up your starship's stats and install newly unlocked upgrades. God knows your ship could use it. Oh, did I say that last part out loud?",
      },
      {
        slug: "train",
        name: "Train Pilot",
        component: <PilotSkills atShipworks={true} />,
        dialog:
          "Let's get you trained up on some sweet new pilot skills. You don't seem like a fast learner, but I'm a great teacher.",
      },
    ],
  };

  return BUILDING_SCREENS[building.type];
};

export default function BuildingInterior() {
  const { building } = useSelector(getBuildingInfo);

  let backgroundImage = null;
  let screens = [] as BuildingScreen[];

  if (!!building) {
    const buildingInfo = getBuildingData(building);
    backgroundImage = buildingInfo.interiorImage;
    screens = getBuildingScreens(buildingInfo);
  }

  if (!building) {
    return null;
  }

  return (
    <BuildingInteriorWrapper bgImage={backgroundImage}>
      {!!building && (
        <BuildingInteriorDisplay building={building} screens={screens} />
      )}
    </BuildingInteriorWrapper>
  );
}
